import * as _ from 'lodash';
import {
    POST_TASK,
    POST_TASK_SUCCESS,
    POST_TASK_ERROR,
    FETCH_TASKS,
    FETCH_TASKS_SUCCESS,
    FETCH_TASKS_FAIL,

    FETCH_TASKS_HISTORY,
    FETCH_TASKS_HISTORY_SUCCESS,
    FETCH_TASKS_HISTORY_ERROR,

    CLEAR_STORE
} from '../actions/types'

const INITIAL_STATE = {
    tasks: [],
    isPostingTask: false,
    tasksLoading: false,

    tasksHistory: [],
    isFetchingHistory: false

}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case POST_TASK:
            return {
                ...state,
                isPostingTask: true
            }
        case POST_TASK_SUCCESS:
            return {
                ...state,
                isPostingTask: false,
                tasks: [...state.tasks, action.payload.task]
            }
        case POST_TASK_ERROR:
            return {
                ...state,
                isPostingTask: false
            }
        case FETCH_TASKS:
            return {
                ...state,
                tasksLoading: true
            }
        case FETCH_TASKS_SUCCESS:
            return {
                ...state,
                tasksLoading: false,
                tasks: action.payload.tasks
            }
        case FETCH_TASKS_FAIL:
            return {
                ...state,
                tasksLoading: false
            }
        case FETCH_TASKS_HISTORY:
            return {
                ...state,
                isFetchingHistory: true,
                tasksHistory: []
            }
        case FETCH_TASKS_HISTORY_SUCCESS:
            return {
                ...state,
                isFetchingHistory: false,
                tasksHistory: action.payload.tasks
            }
        case FETCH_TASKS_HISTORY_ERROR:
            return {
                ...state,
                isFetchingHistory: false
            }
        case CLEAR_STORE:
            return INITIAL_STATE;
        default:
            return state
    }
}  